import { IQueueExecutionProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { JsonEditorSchemaType } from "../models/JsonEditorCdnSchemaType";
import { SchemaCoalesceService } from "./SchemaCoalesceService";
import { AnalysisConfigSchemaCoalesceService } from "./AnalysisConfigSchemaCoalesceService";
import { CalculationsSchemaCoalesceService } from "./CalculationsSchemaCoalesceService";
import { CustomReportsSchemaCoalesceService } from "./CustomReportsSchemaCoalesceService";
import { DataCleaningSchemaCoalesceService } from "./DataCleaningSchemaCoalesceService";
import { PlottingSchemaCoalesceService } from "./PlottingSchemaCoalesceService";
import { TablesSchemaCoalesceService } from "./TablesSchemaCoalesceService";



export class JsonEditorSchemaCoalesceService {


    public static coalesceParsedResultToIQueueExecutionProp = <TEntity, TJsonParsingInputType>(
        schemaType: JsonEditorSchemaType,
        parsingResult: CdnSchemaJsonParsingResult<TEntity, TJsonParsingInputType>): IQueueExecutionProp => {

        if (!schemaType) throw Error("schemaType is required.");
        if (parsingResult == null) throw Error("parsingResult is required.");


        const coalesceService = JsonEditorSchemaCoalesceService.resolveSchemaCoalesceServiceForCdnSchemaType(schemaType);

        const result = coalesceService.coalesceParsingResultparsingResult(parsingResult);

        return result;

    }



    private static resolveSchemaCoalesceServiceForCdnSchemaType = (schemaType: JsonEditorSchemaType): SchemaCoalesceService<any, any, any> => {

        switch (schemaType) {

            case JsonEditorSchemaType.AnalysisConfigSchema:
                return new AnalysisConfigSchemaCoalesceService();
            case JsonEditorSchemaType.CalculationSchema:
                return new CalculationsSchemaCoalesceService();
            case JsonEditorSchemaType.CustomReportSchema:
                return new CustomReportsSchemaCoalesceService();
            case JsonEditorSchemaType.PlotSchema:
                return new PlottingSchemaCoalesceService();
            case JsonEditorSchemaType.RuleSchema:
                return new DataCleaningSchemaCoalesceService();
            case JsonEditorSchemaType.TableSchema:
                return new TablesSchemaCoalesceService();
            default:
                throw Error(`unable to resolve SchemaCoalesceService for schemaType: ${schemaType}!`);
        }

    }


}